import gql from 'graphql-tag'

export default gql`mutation createOrUpdateParticipant($filter:FilterFindOneParticipantInput){
  createOrUpdateParticipant(filter:$filter){
      eventId
    }
  }`
